import { Recurrence, ScheduleDescriptions, SelfServiceSchedulePane } from '@tableau/self-service-schedules';
import { SelfServiceSchedulePaneType } from '@tableau/self-service-schedules/lib/src/components/SelfServiceSchedulePane';
import * as React from 'react';

import { getDefaultTimeZoneDetails } from '~src/schedule/utils/ScheduleUtils';

export type GeocodingScheduleProps = {
    scheduleRecurrence: Recurrence;
    handleScheduleChange: (recurrence: Recurrence) => void;
}

export class GeocodingSchedule extends React.Component<GeocodingScheduleProps, {}> {
    public render(): JSX.Element {
        // add margin to make schedule inline with checkbox text
        const scheduleWrapperStyle: React.CSSProperties = {
            marginLeft: '26px'
        };

        // there's extra margin in SelfServiceSchedulePane which is not needed
        const schedulePaneStyle: React.CSSProperties =  {
            marginTop: '-36px'
        };

        let timeZoneDetails = getDefaultTimeZoneDetails();
        timeZoneDetails.timeZonesEnabled = true;

        return (
            <div style={scheduleWrapperStyle}>
                <span data-tb-test-id='geocoding-scheduling-recurrence-description'>
                    {ScheduleDescriptions.localizeRecurrenceWithOffset(this.props.scheduleRecurrence)}
                </span>
                <div style={schedulePaneStyle}>
                    <SelfServiceSchedulePane
                        recurrenceModel={this.props.scheduleRecurrence}
                        recurrenceModelChangedCallback={this.props.handleScheduleChange}
                        timeZoneDetails={timeZoneDetails}
                        type={SelfServiceSchedulePaneType.Default}
                        uncollapsible={true}
                    />
                </div>
            </div>
        );
    }
  }